import React, { Component } from "react"
import { connect } from "react-redux"
import { Axios, AxiosResponse } from "axios"
import trans from "trans"
import store from "store";
import FileInputComponent from 'react-file-input-previews-base64'
import { Link as RouterLink } from "react-router-dom"
import { PopoverClose } from "@radix-ui/react-popover"
import { find, sortBy } from "lodash"
import { ItemInterface, ReactSortable } from "react-sortablejs"

import {
    css,
    Section,
    Link,
    Checkbox,
    TableSimple, Tr, Td,
    TextInput,
    Popup,
    Switcher,
    Badge,
    Div,
    Button,
    confirm,
    Theme,
    Spinner,
    PopupHint,
    Icon,
    Grid,
    GridCell,
    InputGroup,
} from "@bdfx/mergado-ui-kit"

import { RouterType, withRouter } from "app/components/routes"
import { initForm as initSimpleForm, selectFormValue, selectFormValues } from "app/reducers/form"
import { Query, Template as TemplateType, Template, AlternativeTemplatesLevels, AlternativeTemplate } from "app/types/model-types";
import SectionLoader from "app/components/section-loader"
import { getLocale } from "app/helpers/session"
import Mergado from "app/helpers/mergado";

import {
    Templates,
    reorderTemplates,
    setTemplatesToStore,
    setSizesToStore,
    AltTemplatesReduxList,
    setAlternativeTemplatesLevelsToStore,
} from "template-edit/reducers"

import {
    updateInputValue,
    initForm
} from "app/reducers/form";

import {
    projectId,
    eshopId,
    renameTemplate,
    deleteTemplate,
    pauseTemplate,
    startTemplate,
    duplicateTemplate,
    startOrPauseTemplate,
    getTemplateDiagnostics,
    getQueries,
    getProjectSettings,
    toggleReorderTemplatesAutomatically,
    getWatermarkGroups,
    rerenderTemplate,
    redownloadTemplate,
    getInpaintingGroups,
    getSizes,
    reorderAlternativeTemplates,
} from "app/helpers/api"

import { ID, intboolean, ReduxList } from "app/types/app-types"
import { FiltersFormType, emptyFiltersState } from "products/types/filtertypes";
import { setQueriesToStore } from "actions";
import { setWatermarkGroupsToStore, setInpaintingGroupsToStore } from "watermark-groups/reducers";

import { DiagnosticsPerTemplate, ShowGroupType } from "diagnostics/diagnostics";
import { URL } from "app/config/api-config";
import { RandomProduct } from "shape-edit/types";
import { SettingsFormType } from "app/types/model-types";
import { InpaintingGroupType, WatermarkGroupType } from "products/types";
import { MAX_TEMPLATE_NAME_LENGHT } from 'template-edit/components/save-template-form';
import { getAltTemplateLevelsByLevel, ICONS_VERSION } from "shape-edit/forms/helpers"
import { allowSuperadminForUsers, testUsers } from "template-edit/components/helper"
import { ExportsType, createTemplateExport, downloadTemplateExport } from "app/reducers/exports"
import { ActionType } from "./template-list"
import { SizeItem } from "settings/components/sizes-settings"
import TemplateProgress from "template-edit/components/template-progress"
import { TemplateBadges } from "template-list/template-badges"
import { ConfirmStyles } from "load_styles"
import AlternativeTemplatesTable from "./alternative-templates-table"
import { renderAltLevels } from "shape-edit/forms/fields";

interface OwnProps {
    isImporting: boolean
    importTemplate: Function
    handleCreateNewTemplate: Function
    handleReorderTemplates: Function
    handleTemplatePriority: Function
}

interface DispatchProps {
    router: RouterType
    templates: Templates
    alternativeTemplates: AltTemplatesReduxList
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels[]>
    randomProduct: RandomProduct
    reorderTemplates: typeof reorderTemplates
    setTemplatesToStore: typeof setTemplatesToStore
    setQueriesToStore: typeof setQueriesToStore
    setWatermarkGroupsToStore: typeof setWatermarkGroupsToStore
    setInpaintingGroupsToStore: typeof setInpaintingGroupsToStore
    initForm: typeof initForm
    initSimpleForm: typeof initSimpleForm
    setSizesToStore: typeof setSizesToStore
    setAlternativeTemplatesLevelsToStore: typeof setAlternativeTemplatesLevelsToStore
    filtersForm: FiltersFormType
    updateInputValue: typeof updateInputValue
    exportTemplates: ExportsType
    createTemplateExport: typeof createTemplateExport
    downloadTemplateExport: typeof downloadTemplateExport
    edit_name: string
    edit_priority: number
    sizes: ReduxList<SizeItem>
    queries: ReduxList<Query[]>
    userId: number
}

type Props = OwnProps & DispatchProps

interface ColumnConfig {
    header: React.ReactNode
    content: (row: Template, isSelected: boolean, selectRow: Function ) => JSX.Element
}

interface State {
    isLoading: boolean
    isImporting: boolean
    isLoadingDiagnostics: boolean
    filters: TemplateFilters
    autoPriority: intboolean
    diagnosticsPerTemplate: DiagnosticsPerTemplate[]
    toasts: boolean
    editId: number
    activeColumns: string[]       // identificators of possible columns in table
    currentOrder: any
    active: number
}

export type TemplateEditType = "name" | "priority"

export type TemplateFilters = {
    name: string
    error: string
    active: "active" | "inactive" | "all"
    dynamicOnly: intboolean
}

class TemplatesTable extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            isImporting: false,
            isLoadingDiagnostics: false,
            filters: {
                name: '',
                error: '',
                active: "active",
                dynamicOnly: 0,
            },
            diagnosticsPerTemplate: null,
            toasts: false,
            autoPriority: null,
            editId: null,
            activeColumns: JSON.parse(localStorage.getItem('templatesColumns')) ?? ["handle", "name", "preview", "format", "processed_images", "products", "diagnostics", "actions",],
            currentOrder: [1, 2, 3, 4, 5, 6],
            active: null,
        }

        if (Object.keys(props.filtersForm).length === 0) {
            props.initForm("filtersForm", { ...emptyFiltersState, ...props.filtersForm })
        }
    }

    noProductsYet = <PopupHint icon={<Icon type={'question'} size={20} />}>{trans("no_products_yet")}</PopupHint>
    productsUrl = `/eshop/${eshopId}/project/${projectId}/products/products`

    locale = getLocale().replace('_', '-')

    columns: Record<string, ColumnConfig> = ({
        "handle": {
            header: null,
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const isDraggableItem = !this.state.autoPriority && (row.active || row.active_from || row.active_to)

                return <Td
                    key={`td_${isSelected ? 't' : 'f'}_${row.id}_handle`}
                    className={`${isDraggableItem ? 'handle' : ''} row-even`}
                    width="80px"
                    align="center"
                    style={{
                        cursor: isDraggableItem ? 'grab' : 'pointer',
                        position: "sticky",
                        zIndex: 2,
                        left: 0,
                        clipPath: "polygon(0 0%, 150% 0%,150% 150%,0% 150%)",
                        boxShadow: "1px 0px 3px rgba(0,0,0,0.08)"
                    }}>
                    {isDraggableItem && <Icon type="drag-handle-dots-2-radix" className="unhover" color="#888" size={18} />}
                    <br />
                    <Checkbox style={{ display: "inline-block" }} checked={isSelected} value={true} onChange={() => selectRow(row.id)} />
                </Td>
            }
        },
        "name": {
            header: trans("name"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                if (!this.props.alternativeTemplates.isLoaded && this.props.alternativeTemplatesLevels.isLoaded && this.props.alternativeTemplates.data) {
                    return null
                }

                const reorderAltTemplates = (newList: ItemInterface[]) => {
                    const ids = newList.map(l => l.id)
                    const currentIdsOrder: ItemInterface[] = this.props.alternativeTemplatesLevels.data
                        .filter((al: AlternativeTemplatesLevels) => `${al.template_id}` === `${row.id}`)
                        .map((al: AlternativeTemplatesLevels) => {
                            return al.alternative_template_id
                        })

                    if (currentIdsOrder.join(',') !== ids.join(',')) {
                        //console.debug(`DIFF: set newList ${ids.join(',')} list before: ${currentIdsOrder.join(',')}`)

                        reorderAlternativeTemplates(ids)
                            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                                this.props.setAlternativeTemplatesLevelsToStore(response.data)
                            })
                            .catch((error) => console.error('cannot update priority', error))
                    }
                }

                const levelsForThisTemplate = this.props.alternativeTemplatesLevels.data.filter((al: AlternativeTemplatesLevels) => `${al.template_id}` === `${row.id}`)
                const list: ItemInterface[] = levelsForThisTemplate
                    .map((al: AlternativeTemplatesLevels): ItemInterface => {
                        //find alternative template by id:
                        const alternativeTemplate: AlternativeTemplate = find(this.props.alternativeTemplates.data, (a: AlternativeTemplate) => {
                            return `${al.alternative_template_id}` === `${a.id}`
                        })

                        return {
                            id: al.alternative_template_id,
                            name: alternativeTemplate?.name,
                            priority: al.priority,
                            levels: al.levels,
                            levelsMode: al.levels_mode,
                        }
                    })
                const buttonNewAlternativeTemplate = <Button
                    className="edit"
                    title={trans('new_alternative_template')}
                    onClick={() => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/${row.id}/edit-alt/new`)}
                    simple={true}
                    size="smaller"
                    style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                    icon="file-plus-radix"
                />

                return <Td key={`td_${row.id}_name`} align="left" style={{ position: "relative", gridTemplateColumns: "1fr auto", alignItems: "center", "&:hover .edit": { opacity: 1, pointerEvents: "all", } }}>
                    {this.state.editId === row.id ?
                        <div>
                            <Grid cols="60px 1fr" gap="20px">
                                <TextInput small={true}
                                    type="number"
                                    key={`priority-${this.state.editId}`}
                                    style={{ marginBottom: "15px" }}
                                    label={trans("priority")}
                                    name="quickTemplate.priority"
                                />
                                <TextInput small={true}
                                    style={{ marginBottom: 0 }}
                                    key={`name-${this.state.editId}`}
                                    label={trans("name")}
                                    name="quickTemplate.name"
                                />
                            </Grid>

                            <Button
                                type={'void'}
                                simple={true}
                                icon={<Icon type={'check-slim'} color={Theme.green} />}
                                onClick={this.handleSubmit}
                            />

                            <Button
                                type={'void'}
                                simple={true}
                                icon={<Icon type={'close-light'} color={Theme.red} />}
                                onClick={() => {
                                    this.setEdit(null)
                                }}
                            />
                        </div>
                        :
                        <>
                            <div>
                                <Div marginBottom="20px">{row.priority}. <RouterLink to={`/eshop/${eshopId}/project/${projectId}/templates/${row.id}/edit`}>{row.name}</RouterLink></Div>
                                <TemplateBadges template={row} />
                            </div>

                            <Div position="absolute" top="5px" right="5px">
                                <Button
                                    className="edit"
                                    onClick={() => this.setEdit(row)}
                                    simple={true}
                                    size="smaller"
                                    style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                    icon="pencil-1-radix"
                                />
                            </Div>

                            {(this.props.userId && testUsers.includes(this.props.userId)) &&
                                <Div position="absolute" top="5px" right="45px" width="140px">
                                    {renderAltLevels(getAltTemplateLevelsByLevel(levelsForThisTemplate, 6), this.props.alternativeTemplates.data, `/eshop/${eshopId}/project/${projectId}/templates/${row.id}/edit-alt/`)}
                                </Div>
                            }

                            <Div position="absolute" bottom="5px" right="5px" title={trans('alternative_templates')}>
                                {(this.props.userId && testUsers.includes(this.props.userId)) ?
                                    <ReactSortable      /* sortable some users only */
                                        list={list}
                                        setList={reorderAltTemplates}
                                        animation={150}
                                        ghostClass="ghost">
                                        {list.map((item, i) => {
                                            const a = find(this.props.alternativeTemplates.data, (altTemplate) => {
                                                return `${item.id}` === `${altTemplate.id}`
                                            })

                                            return <Button
                                                key={`button_alternative_template_${item.id}`}
                                                className="edit some-users-only"
                                                title={`${item.name}: (${trans(item.levelsMode).toLowerCase()}${item.levels ? (` ${item.levels}`) : ''})`}
                                                onClick={() => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/${row.id}/edit-alt/${item.id}`)}
                                                simple={true}
                                                size="smaller"
                                                style={{ marginTop: "0px", opacity: 0, pointerEvents: "none", cursor: "pointer", }}
                                                icon={<Icon type={a?.active === 0 ? "cross-2-radix" : "copy-radix"} />}
                                            />
                                        })}
                                        {buttonNewAlternativeTemplate}
                                    </ReactSortable> :
                                    buttonNewAlternativeTemplate
                                }
                            </Div>
                        </>
                    }
                </Td>
            }
        },
        "preview": {
            header: trans("preview"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const timeStamp: number = new Date(`${row.updated_at}`).getTime()
                const thumbnailUrl: string = `${URL.laravelBase}images/thumbs/thumbnail${row.id}.${row.is_anim_gif ? 'gif' : 'png'}?ts=${timeStamp}`

                return <Td width="100px" key={`td_${row.id}_preview_${row.updated_at}`}>
                    <PopupHint icon={<img className="preview" style={{ maxWidth: "80px", maxHeight: "80px", boxShadow: "0px 0px 10px rgba(0,0,0,.1)", }} src={thumbnailUrl} />}>
                        <img className="preview" src={thumbnailUrl} />
                    </PopupHint>
                </Td>
            }
        },
        "format": {
            header: trans("format"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const size = row.size?.id ? find(this.props.sizes.data, (size) => {
                    return `${row.size_id}` === `${size.id}`
                }) : null

                return <Td align="center" key={`td_${row.id}_format`}>
                    {!row.is_keep_size && size?.format ?
                        <Div textAlign="center">
                            {size.format === "custom" ?
                                size.name
                                :
                                <PopupHint icon={<img className="logo" src={`${URL.laravelBase}img/icons/engines/${size.format}.svg?v=${ICONS_VERSION}`} />}>
                                    {size.name}
                                </PopupHint>
                            }
                            <br />
                            <Badge small={true} secondary={true}>{size.width} x {size.height}</Badge>
                        </Div>
                        : trans("keep_original_image_size")
                    }
                </Td>
            }
        },
        "processed_images": {
            header: trans("processed_images"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const diagnostics = this.state.diagnosticsPerTemplate ? find(this.state.diagnosticsPerTemplate, (diagnosticsPerTemplate) => {
                    return diagnosticsPerTemplate.template_id === row.id
                }) : null

                const countAlts = !diagnostics ? '' : (diagnostics.totalAltImages === diagnostics.totalProcessedAltImages ?
                    `${diagnostics.totalProcessedAltImages}` :
                    `${diagnostics.totalProcessedAltImages} / ${diagnostics.totalAltImages}`)

                return <Td align="center" key={`td_${row.id}_processed_images`}>
                    {this.state.isLoadingDiagnostics ?
                        <Spinner type={"bubbles"} /> : diagnostics ?
                            <div>
                                <div title={trans('processed_images')}>
                                    {diagnostics.totalImages}
                                </div>
                                <div title={trans('processed_alt_images')}>
                                    {countAlts}
                                </div>
                            </div>
                            : null
                    }
                </Td>
            },
        },
        "products": {
            header: trans("products"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const diagnostics = this.state.diagnosticsPerTemplate ? find(this.state.diagnosticsPerTemplate, (diagnosticsPerTemplate) => {
                    return diagnosticsPerTemplate.template_id === row.id
                }) : null

                return <Td align="center" key={`td_${row.id}_products`}>
                    <Div textAlign="center">
                        {this.state.isLoadingDiagnostics ?
                            <Spinner type={"bubbles"} />
                            : diagnostics ?
                                <React.Fragment>
                                    <span
                                        className='total-products clickable'
                                        title={trans('total_products')}
                                        onClick={() => {
                                            this.setTemplateFilter(row.id, 'all')
                                            this.props.router.navigate(this.productsUrl)
                                        }}>
                                        {diagnostics.totalProducts !== null ? diagnostics.totalProducts : this.noProductsYet}
                                    </span>
                                    {diagnostics.totalProducts !== null && diagnostics.totalImages !== diagnostics.totalProducts &&
                                        <span title={trans('total_images')}>/{diagnostics.totalImages}</span>
                                    }
                                </React.Fragment> : null
                        }

                        {this.props.queries.isLoaded && row.queries &&
                            <Grid cols={'auto'} gap={'4px'} className="queries">
                                {row.queries.map((queryId, i) => {
                                    const query = find(this.props.queries.data, (query: Query) => {
                                        return `${query.id}` === `${queryId}`
                                    })

                                    if (!query) {
                                        return <GridCell key={queryId} />
                                    }
                                    if (i === 0) {
                                        return <GridCell key={queryId}>
                                            <Link
                                                title={trans('show_in_mergado')}
                                                onClick={() => Mergado.openWindow(`https://app.mergado.com/projects/${projectId}/queries/edit/${queryId}`)}
                                            >
                                                <small>({query.name === '♥ALLPRODUCTS♥' ? trans('all_products') : query.name})</small>
                                                <br />
                                                {row.queries.length > 1 && (
                                                    <Badge onClick={(e) => { e.preventDefault(); e.stopPropagation(); return false; }} color={Theme.blue}>+ {row.queries.length - 1} další</Badge>
                                                )}
                                                {/* <br/><small className="nowrap">{query.product_count} {trans("n_products").toLowerCase()}</small> */}
                                            </Link>
                                        </GridCell>
                                    } else {
                                        return null
                                    }
                                })}
                                {row.queries.length > 1 &&
                                    <Div position="absolute" background="white" zIndex={1000} className="queries-all">
                                        {row.queries.map((queryId, i) => {
                                            const query = find(this.props.queries.data, (query: Query) => {
                                                return query.id === queryId
                                            })
                                            if (!query) {
                                                return <GridCell key={queryId} />
                                            }
                                            return <GridCell key={queryId}>
                                                <Link
                                                    title={trans('show_in_mergado')}
                                                    onClick={() => Mergado.openWindow(`https://app.mergado.com/projects/${projectId}/queries/edit/${queryId}`)}
                                                >
                                                    <small>({query.name === '♥ALLPRODUCTS♥' ? trans('all_products') : query.name})</small>
                                                    {/* <br/><small className="nowrap">{query.product_count} {trans("n_products").toLowerCase()}</small> */}
                                                </Link>
                                            </GridCell>
                                        })}
                                    </Div>
                                }
                            </Grid>
                        }

                    </Div>
                </Td>
            }
        },
        "diagnostics": {
            header: trans("diagnostics"),
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                const diagnostics = this.state.diagnosticsPerTemplate ? find(this.state.diagnosticsPerTemplate, (diagnosticsPerTemplate) => {
                    return diagnosticsPerTemplate.template_id === row.id
                }) : null

                return <Td align="center" key={`td_${row.id}_diagnostics`}>
                    <Div textAlign="center">
                        {this.state.isLoadingDiagnostics ?
                            <Spinner type={"bubbles"} />
                            : diagnostics ? <>
                                <PopupHint icon={<Icon type="exclamation-triangle-radix" color="red">
                                    <span className='status-err clickable' title={trans('with_status_error')} onClick={() => {
                                        this.setTemplateFilter(row.id, 'unavailable')
                                        this.props.router.navigate(this.productsUrl)
                                    }}>
                                        {diagnostics.statusError !== null ? diagnostics.statusError : this.noProductsYet}</span></Icon>}>{trans('image_cannot_be_downloaded')}
                                    </PopupHint><br />

                                <PopupHint icon={<Icon type="view-none-radix" color="red"><span className='empty-images clickable' title={trans('without_images')} onClick={() => {
                                    this.setTemplateFilter(row.id, 'empty_images')
                                    this.props.router.navigate(this.productsUrl)
                                }}>
                                    {diagnostics.missingImages !== null ? diagnostics.missingImages : this.noProductsYet}</span></Icon>}>{trans('product_has_no_image')}
                                </PopupHint><br />

                                <PopupHint icon={<Icon type="code-radix" color="red"><span className='empty-elements clickable' title={trans('empty_elements')} onClick={() => {
                                    this.setTemplateFilter(row.id, null, diagnostics.checkedElements ?? [])
                                    this.props.router.navigate(this.productsUrl)
                                }}>
                                    {diagnostics.emptyElements || 0} </span></Icon>}>{trans('missing_image_element')}
                                </PopupHint>
                            </> : null}

                    </Div>

                    {/* docasne skryto */}
                    {this.props.userId && allowSuperadminForUsers.includes(this.props.userId) &&
                        <div className={'some-users-only'}>
                            <TemplateProgress template={row} />
                        </div>
                    }
                </Td>
            }
        },
        "actions": {
            header: <div style={{ position: "sticky", right: 0, background: "white", width: '65px', textAlign: 'center' }}>
                {trans("action")}
            </div>,
            content: (row: Template, isSelected: boolean, selectRow: Function) => {
                return (
                    <Td key={`td_${row.id}_row`} align="center" className="row-even" width="60px" style={{ textAlign: '-webkit-center', position: "sticky", right: 0, clipPath: "polygon(-10% 0%, 100% 0%,100% 100%,-10% 100%)", boxShadow: "-1px 0px 3px rgba(0,0,0,0.08)"}}>
                        {this.renderPopUp(row, <Button icon={<Icon type="ellypsis-vertical-light" color="blue" size={15} />} color="#eee" style={{ background: "white" }} secondary={true} size="small" />)}
                    </Td>
                )
            }
        },
    })

    handleSortable = (sorted) => {
        this.props.handleReorderTemplates(sorted.map(s => s.id))
    }

    handleSubmit = () => {
        const { editId } = this.state

        const editName = this.props.edit_name
        const editPriority = this.props.edit_priority

        renameTemplate(editId, `${editName}`.substring(0, MAX_TEMPLATE_NAME_LENGHT))
            .then((response: AxiosResponse<any>) => {
                this.props.setTemplatesToStore(response.data)
                this.props.handleTemplatePriority(editId, editPriority)
            })
            .catch((e) => console.error('cannot rename template', e))
            .finally(() => {
                this.setEdit(null)
            })
        this.setEdit(null)
    }

    setColumns = (selectedColumns: string[]) => {
        this.setState({
            activeColumns: [...selectedColumns],
        })
        localStorage.setItem('templatesColumns', JSON.stringify(selectedColumns))
    }

    handleDuplicate = (template: Template) => {
        this.setState({ isLoading: true })
        duplicateTemplate(template.id)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
            })
            .catch((error) => {
                console.error('cannot duplicate template', error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleExport = (templateIds: ID[]) => {
        this.props.createTemplateExport(templateIds, false)
    }

    confirmDelete = (template: Template) => {
        confirm({
            message: trans("confirm_delete"),
            style: ConfirmStyles,
            buttons: [
                <Button key="yes" color={Theme.red} onClick={() => this.handleDelete(template)}>{trans("yes")}</Button>,
                <Button key="no" color={Theme.green} onClick={() => false}>{trans("no")}</Button>
            ]
        })
    }

    handleDelete = (template: Template) => {
        this.setState({ isLoading: true })
        deleteTemplate(template)
            .then((response: AxiosResponse<any>) => {
                this.props.setTemplatesToStore(response.data)
            })
            .catch((error) => {
                console.error("Error when deleting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleRerender = (template: Template) => {
        this.setState({ isLoading: true })
        rerenderTemplate(template.id)
            .then((response: AxiosResponse<any>) => {
                console.debug('renreder', response.data)
            })
            .catch((error) => {
                console.error("Error when re-rendering template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleRedownload = (template: Template) => {
        this.setState({ isLoading: true })
        redownloadTemplate(template.id)
            .then((response: AxiosResponse<any>) => {
                console.debug('redownload', response.data)
            })
            .catch((error) => {
                console.error("Error when re-downloading template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleStartOrPause = (template: Template) => {
        this.setState({ isLoading: true })

        startOrPauseTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
                this.handleFilterActive(template.active ? "active" : "all")
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handlePause = (template: Template) => {
        this.setState({ isLoading: true })

        pauseTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    handleStart = (template: Template) => {
        this.setState({ isLoading: true })
        startTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    confirmBulkDelete = (ids: number[]) => confirm({
        message: trans("confirm__bulk_delete"),
        style: ConfirmStyles,
        buttons: [
            <Button key="yes" color={Theme.red} onClick={() => this.handleBulkAction('delete', ids)}>{trans("yes")}</Button>,
            <Button key="no" color={Theme.green} onClick={() => false}>{trans("no")}</Button>
        ]
    })

    handleBulkAction = (type: ActionType, ids: number[]) => {
        const { exportTemplates, templates } = this.props

        if (type === 'export' && !exportTemplates.isExporting) {
            if (ids.length) {
                this.handleExport(ids)
            }

            return;
        }

        for (const id of ids) {
            const template = find(templates.data, (t: TemplateType) => {
                return t.id === id
            })
            switch (type) {
                case "start":
                    this.handleStart(template)
                    break
                case "pause":
                    this.handlePause(template)
                    break
                case "delete":
                    this.handleDelete(template)
                    break
                case "copy":
                    this.handleDuplicate(template)
                    break;
                case "rerender":
                    this.handleRerender(template.id)
                    break;
                case "redownload":
                    this.handleRedownload(template.id)
                    break;
                default:
                    break
            }
        }
    }

    updateDiagnostics = () => {
        const { filters } = this.state
        this.setState({ isLoadingDiagnostics: true })

        getTemplateDiagnostics(filters.active === "active" ? 1 : 0, filters.name)
            .then((r: AxiosResponse<DiagnosticsPerTemplate[]>) => {
                this.setState({
                    diagnosticsPerTemplate: r.data,
                    isLoadingDiagnostics: true
                })
            })
            .catch(error => {
                console.debug('error while getting template diagnostics', error)
            })
            .finally(() => {
                this.setState({ isLoadingDiagnostics: false })
            })

    }

    componentDidMount(): void {
        getSizes()
            .then((response: AxiosResponse<SizeItem[]>) => {
                this.props.setSizesToStore(response.data)
            })
            .catch((e) => console.error('cannot get sizes', e))

        this.updateDiagnostics()

        getProjectSettings()
            .then((response: AxiosResponse<SettingsFormType>) => {
                this.setState({ autoPriority: response.data.auto_template_priority })
            })
            .catch(error => {
                console.error('error while getting project settings', error)
            })

        getQueries()
            .then((response: AxiosResponse<Query[]>) => {
                this.props.setQueriesToStore(response.data)
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })

        getWatermarkGroups()
            .then((response: AxiosResponse<WatermarkGroupType[]>) => {
                this.props.setWatermarkGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get watermark groups', e)
            })

        getInpaintingGroups()
            .then((response: AxiosResponse<InpaintingGroupType[]>) => {
                this.props.setInpaintingGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get inpainting groups', e)
            })
    }

    componentDidUpdate(prevProps: Readonly<DispatchProps>, prevState: Readonly<State>, snapshot?: any): void {
        if (prevProps && JSON.stringify(prevProps.alternativeTemplatesLevels.data) !== JSON.stringify(this.props.alternativeTemplatesLevels.data)) {
            this.updateDiagnostics()
        }
    }

    handleFilterName = (value: string) => {
        this.setState({
            filters: {
                ...this.state.filters,
                name: value
            },
        })
    }

    handleFilterActive = (value: "all" | "active" | "inactive") => {
        this.setState({
            filters: {
                ...this.state.filters,
                active: value
            },
        })
    }

    handleToggleAutoPriority = (evt) => {
        toggleReorderTemplatesAutomatically(evt)
            .then((response: AxiosResponse<TemplateType[]>) => {
                store.dispatch(setTemplatesToStore(response.data))
            })
            .catch(error => {
                console.error('cannot reorder automatically', error)
            })
            .finally(() => {
                this.setState({ autoPriority: evt })
            })
    }

    setTemplateFilter = (templateId: ID, showGroup: ShowGroupType = 'unavailable', checkElementsAvailability: string[] = null) => {
        if (checkElementsAvailability === null) {
            this.props.initForm('filtersForm', {
                ...emptyFiltersState,
                image: { ...emptyFiltersState.image, showGroup: [showGroup] },
                product: { ...emptyFiltersState.product, template_id: templateId.toString() },
                //productsPerPage:  //getProductsPerPageOnList(),then .....
            })
        } else {
            this.props.initForm('filtersForm', {
                ...emptyFiltersState,
                image: { ...emptyFiltersState.image },
                product: {
                    ...emptyFiltersState.product,
                    template_id: templateId.toString(),
                    check_elements_availability: Object.keys(checkElementsAvailability)
                },
            })
        }
    }

    setEdit = (template) => {
        this.props.initSimpleForm("quickTemplate", { name: template?.name, priority: template?.priority })
        this.setState({ editId: template?.id })
    }

    getSortedList = (): TemplateType[] => {
        return sortBy(this.props.templates.data, [(template) => {
            return new Number(template.priority)
        }]).filter(template => {
            if (this.state.filters.name !== "") {
                const filterName = this.state.filters.name.toLowerCase()
                const templateName = template.name.toLowerCase()
                if (filterName !== "" && templateName.indexOf(filterName) === -1) {
                    return false
                }
            }
            if (this.state.filters.active !== "all") {
                const DateNow = Date.now()
                if (this.state.filters.active === "active") {
                    if ((template.active !== 1) || (template.active_from && template.active_from > DateNow) || (template.active_to && template.active_to < DateNow)) {
                        return false
                    }
                } else {
                    return !template.active
                }
            }
            if (this.state.filters.dynamicOnly === 1) {
                if (template.is_dynamic !== true) {
                    return false
                }
            }
            return true
        })
    }

    renderPopUp = (row: number[] | Template, button: JSX.Element) => {
        const style = {
            textAlign: "left",
            width: "100%"
        }

        return <Popup onOpenAutoFocus={(e) => e.preventDefault()}  side="bottom" icon={button}>
            <Grid gap="5px">
                {Array.isArray(row) ?
                    <React.Fragment>
                        <Button onClick={() => this.handleBulkAction("start", row)} style={style} simple={true} icon="play-radix">{trans("start")}</Button>
                        <Button onClick={() => this.handleBulkAction("pause", row)} style={style} simple={true} icon="pause-radix">{trans("pause")}</Button>
                        <Button onClick={() => this.confirmBulkDelete(row)} style={style} simple={true} icon="trash-radix">{trans("delete")}</Button>
                        <Button onClick={() => this.handleBulkAction("export", row)} style={style} simple={true} icon="download-radix">{trans("export_template")}</Button>
                        <Button onClick={() => this.handleBulkAction("copy", row)} style={style} simple={true} icon="copy-radix">{trans("duplicate")}</Button>
                        {this.props.userId && allowSuperadminForUsers.includes(this.props.userId) &&
                            <React.Fragment>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleBulkAction('rerender', row)} style={style} simple={true} icon="circle-o-notch" className="some-users-only">{trans("rerender")}</Button>
                                </PopoverClose>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleBulkAction('redownload', row)} style={style} simple={true} icon="download-light" className="some-users-only">{trans("redownload")}</Button>
                                </PopoverClose>
                            </React.Fragment>
                        }
                    </React.Fragment> :
                    <React.Fragment>
                        <RouterLink to={`/eshop/${eshopId}/project/${projectId}/previews/template/${row.id}`}><Button style={style} simple={true} icon="magnifying-glass-radix">{trans("preview")}</Button></RouterLink>
                        <RouterLink to={`/eshop/${eshopId}/project/${projectId}/templates/${row.id}/edit`}><Button style={style} simple={true} icon="pencil-1-radix">{trans("edit")}</Button></RouterLink>
                        {row.active ?
                            <Button onClick={() => this.handlePause(row)} style={style} simple={true} icon="pause-radix">{trans("pause")}</Button> :
                            <Button onClick={() => this.handleStart(row)} style={style} simple={true} icon="play-radix">{trans("start")}</Button>
                        }
                        <Button onClick={() => this.handleDuplicate(row)} style={style} simple={true} icon="copy-radix">{trans("duplicate")}</Button>
                        <PopoverClose asChild>
                            <Button onClick={() => this.handleExport([row.id])} style={style} simple={true} icon="download-radix">{trans("export_template")}</Button>
                        </PopoverClose>
                        <Button onClick={() => this.handleDelete(row)} style={style} simple={true} icon="trash-radix">{trans("delete")}</Button>

                        {this.props.userId && allowSuperadminForUsers.includes(this.props.userId) &&
                            <React.Fragment>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleRerender(row)} style={style} simple={true} icon="circle-o-notch" className="some-users-only">{trans("rerender")}</Button>
                                </PopoverClose>
                                <PopoverClose asChild>
                                    <Button onClick={() => this.handleRedownload(row)} style={style} simple={true} icon="download-light" className="some-users-only">{trans("redownload")}</Button>
                                </PopoverClose>
                            </React.Fragment>
                        }
                    </React.Fragment>}
            </Grid>
        </Popup>
    }

    renderActions = (selected: number[]) => {
        const { activeColumns, filters } = this.state

        return (
            <Grid className="actions" cols={`${selected.length > 0 ? "auto" : ""} 1fr auto auto auto auto`} gap="10px" valign="center">
                {selected.length > 0 ?
                    <div>
                        {this.renderPopUp(selected, <Button
                            icon={<Icon type="chevron-down-light" size={15} text={trans("selected") + " ..."} />}
                            size="small"
                        />)}
                    </div> :
                    null
                }

                <TextInput small={true} type="search" value={filters.name} onChange={this.handleFilterName} placeholder={trans('fulltext')} />

                <Switcher value={filters.active} onChange={this.handleFilterActive} items={[
                    { label: trans('active_only'), value: "active" },
                    { label: trans('inactive'), value: "inactive" },
                    { label: trans('all'), value: "all" }
                ]} />

                <Popup side="bottom" icon={<Button size="smaller" color="#e4e4e7" secondary={true}><Icon type="columns" color="#333" text={trans('columns')} /></Button>}>
                    <InputGroup value={activeColumns} onChange={this.setColumns} search={true} orientation="vertical" items={
                        ["preview", "format", "processed_images", "products", "diagnostics"].map((filter => {
                            return ({ label: trans(filter), value: filter })
                        }))
                    } />
                </Popup>

                {this.state.autoPriority ?
                    <Button
                        size={"smaller"}
                        color={"#e4e4e7"}
                        onClick={() => this.handleToggleAutoPriority(false)}
                        icon={<Icon type="sort-amount-asc" color="#333" size={15} text={trans("manual_priority")} />}
                    />
                    :
                    <Button
                        size={"smaller"}
                        secondary={true}
                        color={"#e4e4e7"}
                        onClick={() => this.handleToggleAutoPriority(true)}
                        icon={<Icon type="sort-amount-asc" color="#333" size={15} text={trans("auto_priority")} />}
                    />}
                <Grid cols="auto auto" style={{ ".IconButton > div": { marginTop: "0 !important", }, "> :nth-child(2)": { marginLeft: "-5px", borderLeft: "1px solid #68847d", ".muk-button": { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } } }}>
                    <Button color="green" className={'create-new-button'} onClick={() => this.props.handleCreateNewTemplate()}>
                        {trans("new_template")}
                    </Button>
                    <PopupHint icon={
                        <FileInputComponent
                            key={'import_template'}
                            labelText={null}
                            imagePreview={false}
                            multiple={false}
                            buttonComponent={
                                <Button
                                    color="green"
                                    icon={!this.props.isImporting ? "upload" : <Spinner color="blue" size={15} />}
                                    disabled={this.props.isImporting}
                                />
                            }
                            callbackFunction={(file: File) => this.props.importTemplate(file, false)}
                            accept="application/json"
                        />
                    }>
                        {trans("import_template")}
                    </PopupHint>
                </Grid>

            </Grid>
        )
    }

    setCurrentOrder = (order) => this.setState({ currentOrder: order })
    setActive = (active) => this.setState({ active: active })

    render() {
        const { templates, queries } = this.props

        const activeColumns = Object.entries(this.columns).filter(([id, properties]) => this.state.activeColumns.indexOf(id) > -1).map(([id, properties]) => ({ ...properties, columnId: id }))

        const templatelist = this.getSortedList()
        const templateIds = templatelist.map(t => parseInt(`${t.id}`))
        const templateKeys = templatelist.map(t => `${t.id}_${t.active ? 'a' : 'i'}`).join(',')

        if (!queries.isLoaded || !templates.isLoaded) {
            return <SectionLoader />
        }

        if (templates.isLoaded && this.props.templates.data?.length === 0) {
            return <Grid cols="auto minmax(auto, 650px) auto">
                <GridCell />
                <GridCell>
                    <Section header={trans('main_templates')}>
                        <Div padding="15px" /* maxWidth="600px" */ textAlign="center" fontStyle="italic" margin="auto">
                            <Icon type="image-radix" size={70} color="blue" /><br /><br />
                            {trans("info_no_template")}
                            <br /><br />
                            <Button color="green" size="big" onClick={() => this.props.handleCreateNewTemplate()}>
                                {trans("new_template")}
                            </Button>
                        </Div>
                    </Section>
                </GridCell>
                <GridCell />
            </Grid>
        }

        const levelsKey = this.props.alternativeTemplatesLevels.data.map(l => {
            return `${l.template_id}_${l.alternative_template_id}_${l.levels}`
        })

        const showColumns = [...activeColumns]
        return (
            <div>
                <Section header={trans('main_templates')}>
                    <StyledTable
                        key={`table${templateKeys}`}
                        ids={templateIds}
                        actions={this.renderActions}
                        header={showColumns.filter(c => c.header).map((c, i) => <React.Fragment key={`header_table_${c.header}`}>{c.header}</React.Fragment>)}>
                        {(selected: number[], toggle: (id: number) => void): JSX.Element => templatelist.length > 0
                            ? <ReactSortable
                                filter=".inactive"
                                preventOnFilter={false}
                                list={templatelist.map((t: TemplateType) => ({ id: t.id }))}
                                key={`thead_${templateKeys}_${levelsKey}`}
                                setList={(sorted: ItemInterface[]): void => {
                                    const currentOrder = templatelist.map((t: TemplateType) => t.id).join(',')
                                    const newOrder = sorted.map((t: ItemInterface) => t.id).join(',')
                                    if (currentOrder !== newOrder) {
                                        this.handleSortable(sorted)
                                    }
                                }}
                                handle=".handle" tag="tbody" style={{ display: "contents" }}>
                                {templatelist.map((template: TemplateType, orderIndex: number): JSX.Element => {
                                    const isSelected: boolean = selected.indexOf(parseInt(`${template.id}`)) > -1
                                    const rowClassName: string = template.active ? "" : ((template.active_from || template.active_to) ? "inactive-scheduled" : "inactive")
                                    const dtkey: string = `${showColumns.map((c) => c.columnId).join(',')}-${isSelected ? 'selected' : 'x'}-${templateKeys}-${template.id}-${this.state.editId}-${template.priority}-${template.name}-${this.state.isLoadingDiagnostics ? 'ld' : 'nl'}`

                                    return <Tr className={rowClassName} rowId={template.id} isOdd={true} key={dtkey}>
                                        {showColumns.map((column): JSX.Element => {
                                            const cell = this.columns[column.columnId]
                                            return cell.content(template, isSelected, toggle)
                                        })}
                                    </Tr>
                                })}
                            </ReactSortable>
                            : <Tr key={templateKeys}>
                                <td colSpan={100}>
                                    <Div padding="50px" maxWidth="600px" textAlign="center" margin="auto" fontStyle="italic">
                                        {trans("no_templates_found")}
                                    </Div>
                                </td>
                            </Tr>
                        }
                    </StyledTable>
                </Section>

                <AlternativeTemplatesTable
                    importTemplate={this.props.importTemplate}
                    isImporting={this.props.isImporting}
                    diagnosticsPerTemplate={this.state.diagnosticsPerTemplate}
                    isLoadingDiagnostics={this.state.isLoadingDiagnostics}
                />
            </div>
        )
    }
}

export const StyledTable = css(TableSimple)({
    overflow: 'overlay',
    background: "white !important",
    ".inactive,.inactive-scheduled": {
        opacity: 0.5,
    },
    ".m-header-cell:first-of-type": {
        padding: 0,
        verticalAlign: "middle",
    },
    ".m-header-cell": {
        ".muk-checkbox-wrapper .m-no-label": {
            justifyItems: "center",
        },
    },
    ".preview": {
        position: "relative",
        minHeight: '30px',
        minWidth: '40px',
        maxWidth: '80px',
        maxHeight: '80px',
    },
    ".preview:before": {
        content: "' '",
        display: "block",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: "0",
        background: "rgb(240, 240, 240) url('https://cdn.bdfx.cz/muk/icons/link-break-1-radix.svg') center center no-repeat",
        border: "1px dotted rgb(200, 200, 200)",
    },
    ".logo": {
        maxHeight: "30px",
    },
    ".queries": {
        ".muk-gridcell:hover .query-name": {
            textDecoration: "underline",
        },

        ".queries-all": {
            display: "none",
            padding: "5px 10px",
            border: "1px solid #ccc",
            ".muk-gridcell": {
                margin: "5px 0",
            },
        },
        ":hover .queries-all": {
            display: "block",
        },
    },
})


function mapStateToProps(state) {
    return {
        templates: state.templates,
        alternativeTemplates: state.alternativeTemplates,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        randomProduct: state.randomProduct,
        filtersForm: selectFormValues(state, 'filtersForm'),
        edit_name: selectFormValue(state, "quickTemplate", "name"),
        edit_priority: selectFormValue(state, "quickTemplate", "priority"),
        exportTemplates: state.exportTemplates,
        sizes: state.sizes,
        queries: state.queries,
        userId: state.project.data.user?.id,
    }
}

export default connect(mapStateToProps, {
    reorderTemplates,
    initForm,
    updateInputValue,
    downloadTemplateExport,
    createTemplateExport,
    setTemplatesToStore,
    setQueriesToStore,
    setWatermarkGroupsToStore,
    setInpaintingGroupsToStore,
    setSizesToStore,
    initSimpleForm,
    setAlternativeTemplatesLevelsToStore,
})(withRouter(TemplatesTable));